import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Regex = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M16.102 9.8607L18.6154 13.8922L20.5641 12.4192L17.7484 8.72039L22 7.49701L21.2821 5.12575L16.9668 6.83333L17.1795 2H14.7863L15.0225 6.77142L10.7521 5.05389L10 7.46108L14.42 8.74052L11.5385 12.491L13.5214 14L16.102 9.8607Z"
      fill="currentColor"
    />
    <path d="M8 16H2V22H8V16Z" fill="currentColor" />
  </Icon>
));

export default Regex;
